import React, { useEffect } from "react";
import NavPrimary from "../../../../components/layout/nav/primary";
import MainMenu from "./mainMenu";
import { useGlobalContext } from "../../../../context/global/state";

const MainMenuController: React.FC = () => {
	// TODO: Move to a better place later
	// Device localStorage login
	const currentUser = localStorage.getItem("currentUser");
	const { dispatch } = useGlobalContext();

	// Handles User
	useEffect(() => {
		const action = {
			type: "setCurrentUser",
			payload: { isLoaded: true } as any,
		};
		if (currentUser) {
			let user = JSON.parse(currentUser);
			if (user.email) {
				action.payload.email = user.email;
				action.payload.isLoggedIn = true;
			} else {
				action.payload.isLoggedIn = false;
			}
		}

		dispatch(action);
	}, [dispatch, currentUser]);

	return (
		<>
			<NavPrimary>
				<MainMenu />
			</NavPrimary>
		</>
	);
};

export default MainMenuController;
